import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import ItemList from "./pages/ItemList";
import AddItem from "./pages/AddItem";
import EditItem from "./pages/EditItem";
import "./App.css";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
     <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/allrecyclable" element={<ItemList />} />
      <Route path="/addrecyclable" element={<AddItem />} />
      <Route path="/item/:id" element={<EditItem />} /> 
    </Routes>
    </BrowserRouter>
  );
}
 